module.exports = __webpack_public_path__ + "media/images/member_edit-85a37a18e7b7b4923d35b2c60a63b21a.svg";